import React, { useEffect, useState } from "react";
import moment from "moment";
import { dateTime as SharedDateTime } from "@blocktickets/shared-utils";

import {
  getNowInTimezone,
  formatDateTime,
  formatShortDate,
  getTimezoneDate,
} from "../../../../utilities/helpers";

import Stack from "react-bootstrap/Stack";

import { LoadingContainer } from "../../../LoadingContainer";

import "./countdown.scss";

const scheduleReloadAttempts = new Set();

export default function Countdown({
  reloadQuickPicks,
  scheduledTime,
  timezone,
  showHeader = true,
}) {
  const [months, setMonths] = useState();

  const [days, setDays] = useState();

  const [hours, setHours] = useState();

  const [minutes, setMinutes] = useState();

  const [seconds, setSeconds] = useState();

  const padWithZeros = (num) => {
    if (num < 10) {
      return `0${num}`;
    } else {
      return num;
    }
  };

  useEffect(() => {
    if (!scheduledTime || !timezone) {
      return;
    }

    const timer = setInterval(() => {
      const now = getNowInTimezone(timezone);
      const ticketDate = getTimezoneDate(scheduledTime, timezone);
      if (!ticketDate) return;
      const duration = moment.duration(ticketDate.diff(now));

      setMonths(padWithZeros(duration.months()));
      setDays(padWithZeros(duration.days()));
      setHours(padWithZeros(duration.hours()));
      setMinutes(padWithZeros(duration.minutes()));
      setSeconds(padWithZeros(duration.seconds()));

      // If countdown is finished
      if (ticketDate.isSameOrBefore(now)) {
        clearInterval(timer);
        const reloadKey = `${scheduledTime}-${timezone?.abbr || timezone?.iana || timezone?.offset || "tz"}`;
        if (
          typeof reloadQuickPicks === "function" &&
          !scheduleReloadAttempts.has(reloadKey)
        ) {
          scheduleReloadAttempts.add(reloadKey);
          reloadQuickPicks();
        }
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [scheduledTime, timezone, reloadQuickPicks]);

  const getTimezoneName = (format) => {
    const tz = SharedDateTime.ensureIanaTimeZone(timezone, "UTC");
    const dateWithName = new Intl.DateTimeFormat("en-US", {
      timeZone: tz,
      timeZoneName: format,
    }).format(new Date());

    return dateWithName?.split(" ")?.pop();
  };

  return (
    <>
      <div id="countdown" className={`${showHeader ? "icon" : ""}`}>
        {showHeader && <p className="small">Tickets will be on sale</p>}
        <span className="date">
          <span>
            {formatShortDate(
              getTimezoneDate(scheduledTime, timezone),
              "dateOnlyWithDay",
            )}
          </span>
          <span className="mx-2">at</span>
          <span>
            {formatDateTime(
              getTimezoneDate(scheduledTime, timezone),
              "timeOnly",
            )}
          </span>
          <span className="mx-2">{getTimezoneName("short")}</span>
        </span>
      </div>
    </>
  );
}
